module.exports = __webpack_public_path__ + "static/media/AMAZON_BRANCO.d4e5300d.svg";